
import type { GameData } from './types';

// Stable default data constant to avoid dependencies issues
export const DEFAULT_GAME_DATA: GameData = {
  bestScore: 0,
  totalGamesPlayed: 0,
  currentStreak: 0,
  lastPlayedDate: '',
  unlockedFacts: [],
  unlockedLevels: [1], // Level 1 is always unlocked
  completedGrids: {},
  dailyChallengeCompleted: false
};
